// extracted by mini-css-extract-plugin
export var darkMode = "_h-0";